import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Grid } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { SuccessContainer } from '../../components';

import './auth.scss';

class PasswordChangeSuccess extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <Grid.Row>
        {/* <Grid.Column mobile={16} tablet={5} computer={5} />
        <Grid.Column mobile={16} tablet={6} computer={6}> */}
        <Container className="email-verification-container">
          <Grid>
            <Grid.Row>
              <SuccessContainer
                msg={t('auth.password_changed.success_title')}
                description={[
                  <span>{t('auth.password_changed.success_line_1')}</span>,
                  <br />,
                  <span>{t('auth.password_changed.success_line_2')}</span>,
                ]}
                success={true}
                button={t('auth.password_changed.success_button')}
                buttonRoute="/signin"
              />
            </Grid.Row>
          </Grid>
        </Container>
        {/* </Grid.Column>
        <Grid.Column mobile={16} tablet={5} computer={5} /> */}
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

PasswordChangeSuccess = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PasswordChangeSuccess));

export default PasswordChangeSuccess;
